import { render, staticRenderFns } from "./bar-period-sales.vue?vue&type=template&id=50179a53&scoped=true&"
import script from "./bar-period-sales.vue?vue&type=script&lang=js&"
export * from "./bar-period-sales.vue?vue&type=script&lang=js&"
import style0 from "./bar-period-sales.vue?vue&type=style&index=0&id=50179a53&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50179a53",
  null
  
)

export default component.exports